import styled from "styled-components";

export const FeedHeader = styled.div`
  align-items: baseline;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const FeedTitle = styled.h2`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 20px;
  font-weight: 800;
  margin: 0;
`;

export const FeedSubtitle = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 13px;
`;

export const FeedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SentinelRow = styled.div`
  height: 1px;
`;

export const LoadingMoreRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 18px 0;
`;

export const Spinner = styled.div`
  animation: activity-feed-spin 0.7s linear infinite;
  border: 2px solid rgba(143, 169, 175, 0.2);
  border-radius: 50%;
  border-top-color: ${({ theme }) => theme.colors.envy};
  height: 22px;
  width: 22px;

  @keyframes activity-feed-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 14px;
  padding: 40px 24px;
  text-align: center;
`;

export const ErrorState = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.chalk};
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 12px;
  padding: 40px 24px;
  text-align: center;
`;

export const LoadMoreError = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.chalk};
  display: flex;
  font-size: 13px;
  gap: 10px;
  justify-content: center;
  padding: 8px 0;
`;

export const RetryButton = styled.button`
  background: transparent;
  border: 1px solid rgba(143, 169, 175, 0.28);
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  padding: 6px 14px;

  &:hover {
    background: rgba(143, 169, 175, 0.1);
  }
`;
